import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, StampIcon, Clock, FileText, Search } from 'lucide-react';
import { visas, flagUrl, priceText } from '../visaData';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';

export default function VisaList() {
  const [q, setQ] = useState('');
  const filtered = visas.filter((v) => v.country.toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div className="bg-white">
      <Header />
      <section className="relative pt-32 pb-14 bg-[#0B2545] overflow-hidden">
        <div className="absolute inset-0 opacity-[0.08] bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1600&q=60')" }} />
        <div className="relative max-w-6xl mx-auto px-5 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm mb-4"><ArrowLeft size={16} /> Back to home</Link>
          <p className="section-eyebrow text-[#ff9a6a] mb-2"><span className="h-px w-8 bg-[#EA5019] inline-block" /> VISA SERVICES</p>
          <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-white flex items-center gap-3"><StampIcon className="text-[#ff7a45]" size={38} /> Apply for Your Visa</h1>
          <p className="text-white/75 mt-3 max-w-2xl">End-to-end visa assistance with transparent pricing and expert documentation support. Choose a country to view requirements and apply online.</p>
          <div className="relative mt-6 max-w-md">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              data-testid="visa-search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search country (e.g. Dubai, Singapore)…"
              className="w-full rounded-full bg-white pl-11 pr-4 py-3 text-[#0B2545] placeholder-slate-400 outline-none focus:ring-2 focus:ring-[#EA5019]/40 shadow-lg"
            />
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 md:px-8 py-14">
        {filtered.length === 0 ? (
          <div className="bg-[#f6f8fb] rounded-2xl p-12 text-center text-slate-500" data-testid="visa-empty-state">
            No visas found for "{q}". <button onClick={() => setQ('')} className="text-[#EA5019] font-semibold">Clear search</button>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="visa-list-grid">
            {filtered.map((v) => (
              <Link
                key={v.slug}
                to={`/visas/${v.slug}`}
                data-testid={`visa-card-${v.slug}`}
                className="group rounded-2xl overflow-hidden border border-slate-100 shadow-[0_10px_30px_rgba(11,37,69,0.06)] hover:shadow-[0_20px_50px_rgba(11,37,69,0.14)] transition-all duration-300 hover:-translate-y-1 bg-white flex flex-col"
              >
                <div className="relative h-28 bg-gradient-to-br from-[#0B2545] to-[#123a63] flex items-center gap-4 px-6">
                  <img src={flagUrl(v.countryCode)} alt={`${v.country} flag`} className="h-12 w-16 object-cover rounded shadow-lg ring-1 ring-white/20" />
                  <div>
                    <h3 className="font-heading text-lg font-extrabold text-white leading-tight">{v.country}</h3>
                    <span className="text-white/70 text-sm">{v.visaType}</span>
                  </div>
                  <span className="absolute top-3 right-4 text-[11px] font-semibold px-2.5 py-1 rounded-full bg-white/15 text-white">{v.visaMode}</span>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-slate-600">
                    <span className="flex items-center gap-1.5"><Clock size={15} className="text-[#EA5019]" /> {v.processingTime}</span>
                    <span className="flex items-center gap-1.5"><FileText size={15} className="text-[#EA5019]" /> {v.documents.length} documents</span>
                  </div>
                  <div className="mt-4 pt-4 border-t border-slate-100 flex items-center justify-between">
                    <div>
                      <span className="text-xs text-slate-400">{v.quoteOnly ? 'Price' : 'Starting from'}</span>
                      <p className="font-heading text-xl font-extrabold text-[#0B2545]">{priceText(v)}</p>
                    </div>
                    <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#EA5019] text-white text-sm font-semibold group-hover:bg-[#cf4413] transition">
                      Apply <ArrowRight size={15} />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
